import { render, staticRenderFns } from "./videoRealTime2.vue?vue&type=template&id=0bea5988&scoped=true"
import script from "./videoRealTime2.vue?vue&type=script&lang=js"
export * from "./videoRealTime2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea5988",
  null
  
)

export default component.exports